import { render, staticRenderFns } from "./HSCodesAdmin.vue?vue&type=template&id=50cafe50&scoped=true"
import script from "./HSCodesAdmin.vue?vue&type=script&lang=js"
export * from "./HSCodesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cafe50",
  null
  
)

export default component.exports